export default __webpack_public_path__ + "static/media/009-healthy diet.fc4c4482.svg";